import React from 'react';

import Icon from './Icon';

export interface PaginatorProps {
  canGoNext: boolean;
  canGoPrev: boolean;
  nextPage?: number;
  prevPage?: number;
  goNextPage?: () => void;
  goPrevPage?: () => void;
}

const Paginator: React.FC<PaginatorProps> = (props) => {
  return (
    <div className="flex justify-center mt-4 py-5">
      <button
        className={` mr-2 px-4 py-2 rounded-md flex items-center gap-3 ${props.canGoPrev ? ' text-dark cursor-pointer' : ' text-secondary-700 cursor-not-allowed'}`}
        onClick={props.goPrevPage}
        disabled={!props.canGoPrev}
      >
        <Icon name="chevron-left" />
        <div className="text-xs">Anterior</div>
      </button>
      <button
        className={`cursor-pointer ml-2 px-4 py-2 rounded-md flex items-center gap-3 ${props.canGoNext ? ' text-dark' : ' text-secondary-700 cursor-not-allowed'}`}
        onClick={props.goNextPage}
        disabled={!props.canGoNext}
      >
        <div className="text-xs">Siguiente</div>
        <Icon name="chevron-right" />
      </button>
    </div>
  );
};

export default Paginator;
